/** Базовый класс поля ввода. */
export class Input {
  /**
   * Создает компонент ввода текста.
   *
   * @param {object} props Параметры компонента.
   * @param {HTMLElement} props.container Родительский элемент.
   * @param {HTMLInputElement} props.input Элемент ввода.
   */
  constructor({container, input}) {
    this.el = container;
    this.input = input;
    this.updateIsFilledStatus();
    this.bindEventListeners();
  }

  /**
   * Вешает коллбеки событий на элементы компонента.
   *
   * @returns {void}
   */
  bindEventListeners() {
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keyup', this.onInput.bind(this));
    this.input.addEventListener('updateClass', this.updateClass.bind(this));
    this.input.addEventListener('beforeinput', this.onBeforeInput.bind(this));
    window.addEventListener('load', () => {
      this.updateIsFilledStatus();
    });
  }

  /**
   * Обновить класс заполненности.
   *
   * @returns {void}
   */
  updateClass() {
    if (this.input.value) {
      this.el.classList.add('filled');
    } else {
      this.el.classList.remove('filled');
    }
  }

  /**
   * Получает введенное значение.
   *
   * @returns {string} Введеное значение.
   */
  getValue() {
    return this.input.value;
  }

  /**
   * Проверяет наличие лейбла.
   *
   * @returns {HTMLElement} Лейбл поля ввода.
   */
  hasLabel() {
    return this.el.querySelector('.form-field__label');
  }

  /**
   * Обновляет состояние ввода, которое говорит, введено ли значение в поле, или нет.
   *
   * @returns {void}
   */
  updateIsFilledStatus() {
    if (this.getValue() && this.hasLabel()) {
      this.el.classList.add('filled');
    } else {
      this.el.classList.remove('filled');
    }
  }

  /**
   * Колбэк обработки события 'input'.
   *
   * @returns {void}
   */
  onInput() {
    this.updateIsFilledStatus();
    if (this.input.maxLength > 0 && this.input.maxLength < this.input.value.length) {
      this.input.value = this.input.value.slice(0, this.input.maxLength);
    }
  }

  /**
   * Колбэк обработки события перед вводом - удаление символов, не удовлетворяющих паттерну.
   *
   * @param {Event} event Событие, происходящее при вводе в инпуте.
   * @returns {void}
   */
  onBeforeInput(event) {
    const patternData = this.input.pattern || this.input.dataset.pattern;
    if (patternData && event.data) {
      const pattern = new RegExp(patternData);
      if (!pattern.test(event.data)) {
        event.preventDefault();
      }
    }
  }

  /**
   * Удаляет лишние символы из строки по паттерну.
   *
   * @param {string} str Строка для форматирования.
   * @returns {string} Результат.
   */
  replaceBadCharacters(str) {
    let last = '';
    const patternData = this.input.pattern || this.input.dataset.pattern;
    const match = str.match(patternData);

    if (match || str === '') {
      last = match ? match[0] : '';
    }
    return last;
  }
}
